import React from 'react';

import { CardMedia } from '@mui/material';

import type { ScreenshotImageProperties } from './ScreenshotImage.types';

export const ScreenshotImage: React.FC<ScreenshotImageProperties> = ({
  screenshotUrl = '',
  onImageError,
  dataTest = 'screenshot_image',
}) => (
  <CardMedia
    data-testid={dataTest}
    component='img'
    image={screenshotUrl}
    onError={onImageError}
    sx={{ height: 160, objectFit: 'cover' }}
  />
);
